import styled from "styled-components";
import {
  border,
  brand,
  radius,
  spacing,
  surface,
  text,
  typography,
} from "../../theme/tokens";

/**
 * Mobile inbox styled components (Mobile DMS v1, Phase 2).
 *
 * Stacked list → detail flow: `/inbox` renders the full-width list,
 * `/inbox/:documentId` renders a full-height detail screen (header /
 * collapsible briefing / viewer / action footer). Kept separate from
 * `InboxStyled.js` so the desktop 3-pane surface and this one can
 * evolve independently.
 */

export const MobileInboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: ${surface.surface};
`;

// ---------------------------------------------------------------------------
// Detail screen
// ---------------------------------------------------------------------------

export const DetailHeader = styled.header`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  border-bottom: 1px solid ${border.light};
  background: ${surface.surface};
  flex-shrink: 0;
`;

export const DetailBackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border: none;
  border-radius: ${radius.md};
  background: transparent;
  color: ${brand.primary};
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &:focus-visible {
    outline: 2px solid ${brand.primary};
    outline-offset: -2px;
  }
`;

export const DetailTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
`;

export const DetailTitle = styled.div`
  font-size: ${typography.size.md};
  font-weight: ${typography.weight.bold};
  color: ${text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailSubtitle = styled.div`
  font-size: ${typography.size.xs};
  color: ${text.tertiary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DetailViewerArea = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

// ---------------------------------------------------------------------------
// Collapsible briefing section
// ---------------------------------------------------------------------------

export const BriefingSection = styled.section`
  flex-shrink: 0;
  border-bottom: 1px solid ${border.light};
  background: ${surface.surface};
`;

export const BriefingToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[2]};
  width: 100%;
  padding: ${spacing[2.5]} ${spacing[3]};
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: ${typography.size.sm};
  font-weight: ${typography.weight.semibold};
  color: ${brand.primary};
  -webkit-tap-highlight-color: transparent;
`;

export const BriefingToggleLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1.5]};
`;

export const BriefingBody = styled.div`
  max-height: 40vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 ${spacing[3]} ${spacing[3]};
`;

export const BriefingStatusText = styled.div`
  padding: ${spacing[2]} 0;
  font-size: ${typography.size.sm};
  color: ${text.muted};
`;
